'use strict';

module.exports = function (value) {
	if (value == null) throw new TypeError("Cannot use null or undefined");
	return value;
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/dan/p/react-devtools/~/es5-ext/object/valid-value.js
 ** module id = 197
 ** module chunks = 0
 **/